import { FC } from 'react';
import { ReactComponent as LogoSvg } from '../../images/eduki_logo_1003_02.svg';
import DomainSensitiveLink from '../domain-sensitive-link/domain-sensitive-link';
import cn from '../../utils/classnames';
import Routes from '../../constants/routes';

type LogoProps = {
    big?: boolean;
    className?: string;
};

const Logo: FC<LogoProps> = (props) => (
    <DomainSensitiveLink {...props} href={Routes.HOME.path}>
        <LogoSvg className={cn('d-md-block logo-big')} />
    </DomainSensitiveLink>
);

export default Logo;
